/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertFamilyHistoryRequestDto
 */
export interface UpsertFamilyHistoryRequestDto {
    /**
     * Identity of the Family member
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    familyMemberId?: string;
    /**
     * Cancer type
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    cancer?: string;
    /**
     * Diabetes details
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    diabetes?: string;
    /**
     * Autoimmune disease details
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    autoimmuneDisease?: string;
    /**
     * Heart disease details
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    heartDisease?: string;
    /**
     * Stroke details
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    stroke?: string;
    /**
     * Other disease
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    other?: string;
    /**
     * Additional information
     * @type {string}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    additionalInformation?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof UpsertFamilyHistoryRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the UpsertFamilyHistoryRequestDto interface.
 */
export function instanceOfUpsertFamilyHistoryRequestDto(value: object): value is UpsertFamilyHistoryRequestDto {
    return true;
}

export function UpsertFamilyHistoryRequestDtoFromJSON(json: any): UpsertFamilyHistoryRequestDto {
    return UpsertFamilyHistoryRequestDtoFromJSONTyped(json, false);
}

export function UpsertFamilyHistoryRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertFamilyHistoryRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'familyMemberId': json['familyMemberId'] == null ? undefined : json['familyMemberId'],
        'cancer': json['cancer'] == null ? undefined : json['cancer'],
        'diabetes': json['diabetes'] == null ? undefined : json['diabetes'],
        'autoimmuneDisease': json['autoimmuneDisease'] == null ? undefined : json['autoimmuneDisease'],
        'heartDisease': json['heartDisease'] == null ? undefined : json['heartDisease'],
        'stroke': json['stroke'] == null ? undefined : json['stroke'],
        'other': json['other'] == null ? undefined : json['other'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function UpsertFamilyHistoryRequestDtoToJSON(json: any): UpsertFamilyHistoryRequestDto {
    return UpsertFamilyHistoryRequestDtoToJSONTyped(json, false);
}

export function UpsertFamilyHistoryRequestDtoToJSONTyped(value?: UpsertFamilyHistoryRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'familyMemberId': value['familyMemberId'],
        'cancer': value['cancer'],
        'diabetes': value['diabetes'],
        'autoimmuneDisease': value['autoimmuneDisease'],
        'heartDisease': value['heartDisease'],
        'stroke': value['stroke'],
        'other': value['other'],
        'additionalInformation': value['additionalInformation'],
        'isOnboarding': value['isOnboarding'],
    };
}

